import { render, staticRenderFns } from "./StateChangeModalComponent.vue?vue&type=template&id=04479438"
import script from "./StateChangeModalComponent.vue?vue&type=script&lang=js"
export * from "./StateChangeModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports